/*
 * Define a form page allowing the user to enter the previously reported date.
 */
import css from './pages.module.css'
import { approxDateMessage } from '../validators/dateYup'
import { datePage } from './datePage'

export const previouslyReportedDatePage = propOverrides => {
  const props = {
    pageId: 'previously_reported_date_page',
    fieldName: 'previously_reported_date',
    required: true,
    label: 'When did you first report the fraudulent activity?',
    hint: approxDateMessage,
    labelClassName: css.largeDateLabel,
    ...propOverrides
  }

  return datePage({ ...props })
}
